import React from 'react';
import { Heart, Target, Shield, Sparkles } from 'lucide-react';
export function KidsRespect() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-1988">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1989">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1990">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1991">
            Respect, Goals & Self-Control
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-1992">
            Storm coaches teach kids that real strength shows up as
            self-control. We don't use guilt or fear — just clear expectations,
            consistent coaching, and a culture of respect kids actually want to
            be part of.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1993">
          {[{
          icon: Heart,
          title: 'Respect',
          desc: 'For coaches, peers, parents, and themselves — the foundation of every class.'
        }, {
          icon: Target,
          title: 'Goal Setting',
          desc: 'Belts and stripes turn big goals into achievable steps kids can see and feel.'
        }, {
          icon: Shield,
          title: 'Self-Control',
          desc: 'Kids learn to manage emotions and impulses — even when training gets intense.'
        }, {
          icon: Sparkles,
          title: 'Healthy Mind, Body & Spirit',
          desc: 'Real Taekwondo is about tools for a healthy, balanced life — not just fighting.'
        }].map((b, i) => <div key={i} className="bg-off-white border border-subtle-gray rounded-2xl p-6 flex flex-col gap-3" data-id="element-1994">
              <div className="w-12 h-12 bg-storm-red/10 rounded-xl flex items-center justify-center text-storm-red" data-id="element-1995">
                <b.icon className="w-6 h-6" data-id="element-1996" />
              </div>
              <h3 className="text-lg text-ink leading-tight" data-id="element-1997">{b.title}</h3>
              <p className="text-gray-warm text-sm leading-relaxed" data-id="element-1998">{b.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}